import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './config/App'
import { Provider } from 'react-redux'
import { ConfigProvider } from 'antd'

import store from './redux/store'


const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#289FC9',
        },
      }}
    >
      <App />
    </ConfigProvider>
  </Provider>
)
